module.exports = __webpack_public_path__ + "img/doors.c08a7d67.svg";